module.exports = "<div class=\"y-formview\" data-bind=\"visible:visible\">\n  <label for=\"\" style=\"display: block\" data-bind=\"style:{width: $parent.labelWidth}\">\n  </label>\n  <div class=\"y-formview-ctn\" data-bind=\"style:{'margin-left': $parent.labelWidth}\">\n    <span class=\"y-formview-label\" data-bind=\"text:label\"></span>\n    <div class=\"y-formview-wrapper\" data-bind=\"style:style\">\n      <!-- ko template: { nodes: $componentTemplateNodes} --><!-- /ko -->\n    </div>\n    <div class=\"clearfix\"></div>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/formview/index.html
// module id = 398
// module chunks = 0